import React, {useState } from 'react';
import DataTable from '../datatable';
import AddIcon from '@material-ui/icons/Add';
import mtStyles from '../../styles/mtStyles';
import { Button, Link, Typography, IconButton } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'material-ui-snackbar-provider';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@material-ui/core';
import { useSelector } from 'react-redux';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';

import { useGetAllEmailTemplatesQuery, useSetOngoingEmailTemplateMutation } from '../../apis/backend';


const EmailTemplateList = () => {
  const chainId = useSelector(state => state.doris.selectedChain);
  const siteId = useSelector(state => state.doris.selectedSite);

  const skipGetAllEmailTemplates = !(chainId && siteId);
  /* eslint-disable no-unused-vars */
  const { data: templates, isLoading, error } = useGetAllEmailTemplatesQuery({ chainId, siteId }, { skip: skipGetAllEmailTemplates });
  const [setOngoingEmailTemplate] = useSetOngoingEmailTemplateMutation();

  const [openDialog, setOpenDialog] = useState(false);
  const [ongoingCandidate, setOngoingCandidate] = useState();

  const history = useHistory();
  const snackbar = useSnackbar();

  const classes = mtStyles();

  const editEmailTemplate = (id) => {
    history.push(`/templates/email/${id}`);
  };

  const { t } = useTranslation();

  const columns = [
    {
      Header: t('ongoing'),
      accessor: 'ongoing'
    },
    {
      Header : 'id',
      accessor : 'id'
    },
    {
      Header : t('title'),
      accessor : 'title'
    },
    {
      Header : t('text-description'),
      accessor : 'message_content',
    },
    {
      Header : t('text-created'),
      accessor : 'created'
    }
  ];

  const mapTableBody = (templates) => {
    return (
      templates.map((template, index) => (
        <TableRow
          style={index % 2 ? { background: '#FBFBFB' } : { background: 'white' }}
          key={index}>
          <TableCell style={{ width: '1%', textAlign: 'center' }}>
            <Link
              onClick={() => {
                setOngoingCandidate(template);
                setOpenDialog(true);
              }}>
              <IconButton>
                { template.ongoing
                  ? <StarIcon color="primary" />
                  : <StarBorderIcon className={classes.unstarred} />
                }
              </IconButton>
            </Link>
          </TableCell>
          <TableCell>
            <Typography noWrap>{template.id}</Typography>
          </TableCell>
          <TableCell>
            <Link
              className={classes.link}
              onClick={() => editEmailTemplate(template.id)}
            >
              <Typography noWrap>{template.title}</Typography>
            </Link>
          </TableCell>
          <TableCell style={{ maxWidth: 400 }}>
            <Typography noWrap>This template was created for testing purposes.</Typography>
          </TableCell>
          <TableCell style={{ maxWidth: 400 }}>
            <Typography noWrap>{(new Date(template.created)).toLocaleString('se-FI')}</Typography>
          </TableCell>
        </TableRow>
      ))
    );
  };

  return (
    <>
      <div className={classes.pageActions}>
        <Button
          style={{ display: 'none' }}
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => history.push({ pathname: '/templates/email/add' })}>
          {t('add-email-template')}
        </Button>
      </div>
      <DataTable
        isLoading={isLoading}
        columns={columns}
        data={templates || []}
        mapTableBody={mapTableBody} />

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}>
        <DialogTitle
          id="alert-dialog-title">
          {t('template-as-default-title')}
        </DialogTitle>

        <DialogContent>
          <DialogContentText
            id="alert-dialog-description">
            { ongoingCandidate && ongoingCandidate.ongoing
              ? t('template-as-default-remove', { ongoingCandidate })
              : t('template-as-default-message', { ongoingCandidate })
            }
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpenDialog(false)}
            color="default">
            {t('cancel')}
          </Button>

          <Button
            onClick={async () => {
              setOpenDialog(false);
              try {
                const result = await setOngoingEmailTemplate({ id: ongoingCandidate.id, chainId, siteId }).unwrap();
                if (result) {
                  snackbar.showMessage(t('template-as-default', {ongoingTemplate: ongoingCandidate}));
                } else {
                  snackbar.showMessage(t('template-as-default-remove-success', {ongoingTemplate: ongoingCandidate}));
                }
              } catch (error) {
                snackbar.showMessage(t('template-as-default-error', {ongoingTemplate: ongoingCandidate}));
              }
            }}
            color="primary">
            {t('save')}
          </Button>
        </DialogActions>
      </Dialog>


    </>
  );
};


export default EmailTemplateList;
